import React from 'react';
import { formatCurrency } from '../../lib/helpers/formatters';

const TotalTrPanoramica = ({ totals = {} }) => {
  const { lastYearPanoramica = 0 } = totals;

  return (
    <tr>
      <td />
      <td />
      <td />
      <td />
      <td className="txt-table-right">
        <strong>SALDO ANNO PRECEDENTE</strong>:{' '}
        {formatCurrency(lastYearPanoramica)}
      </td>
    </tr>
  );
};

export default TotalTrPanoramica;
